import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import b from 'b_';
import { CalendarIntervalDay, SimpleCallback } from 'platform-components';
import React, { useMemo } from 'react';

import { CourseCalendarControls } from 'common.components/calendar-controls/calendar-controls';
import { MarkedDay } from 'common.components/week-picker/week-picker';

import { COURSE_CALENDAR_MIN_DATE, block } from '../constants';
import { MarkedMonthDays } from '../typings';
import { formatMarkedMonthDaysForWeekPicker } from '../utils';

import './course-calendar__controls.scss';

interface CalendarControlsProps {
    interval: CalendarIntervalDay[];
    markedMonthDays: MarkedMonthDays;
    markedMonthDaysLoadingStatus: LOADING_STATUSES;
    onPrevButtonClick: SimpleCallback;
    onNextButtonClick: SimpleCallback;
    onChangeWeek: (startDate: Date, endDate: Date) => void;
    onChangeMonth: (month: Date) => void;
    additionalControls?: React.ReactNode | Array<React.ReactNode>;
}

export const CalendarControls = ({
    interval,
    markedMonthDays,
    onChangeMonth,
    markedMonthDaysLoadingStatus,
    onPrevButtonClick,
    onNextButtonClick,
    onChangeWeek,
    additionalControls,
}: CalendarControlsProps) => {
    const { start, end } = useMemo(() => {
        return interval.length
            ? {
                  start: new Date(interval[0]?.date),
                  end: new Date(interval[interval.length - 1]?.date),
              }
            : { start: new Date(), end: new Date() };
    }, [interval]);

    const markedDays: MarkedDay[] = useMemo(() => {
        return formatMarkedMonthDaysForWeekPicker(markedMonthDays);
    }, [markedMonthDays]);

    return (
        <div className={b(block, 'controls-wrapper')}>
            <CourseCalendarControls
                endDate={end}
                isLoading={markedMonthDaysLoadingStatus === LOADING_STATUSES.LOADING}
                markedDays={markedDays}
                minDate={COURSE_CALENDAR_MIN_DATE}
                mix={b(block, 'calendar-controls')}
                onChangeMonth={onChangeMonth}
                onChangeWeek={onChangeWeek}
                onNextButtonClick={onNextButtonClick}
                onPrevButtonClick={onPrevButtonClick}
                startDate={start}
            />
            <div className={b(block, 'additional-controls')}>{additionalControls}</div>
        </div>
    );
};
